import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "react-accessible-accordion/dist/fancy-example.css";
//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Alert from "reactstrap/lib/Alert";
import XLSX from "xlsx";
import readXlsxFile from "read-excel-file";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import * as FileSaver from "file-saver";
import exportToCSV from '../../../Common/exportcsv';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';



const Heading = [['ID','Sub Category  ','Category','Rs Per KG ','Rs Per CFT']]
var url = window.location.hostname;
var port = window.location.port;

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
   
    this.toggle = this.toggle.bind(this);

    this.state = {
      ShowpopupLoader: false,
      showFilter: false,
      ShowConfirmLoader: false,
      stationType: [],
      unAssignOrder: [],
      assignOrder: [],
      isDisabledSearch: false,
      showConfirmError: false,
      group_id: "",
      selectedOutlet: "",
      selectedDistributor: "",
      selectedLocation: "",
      selectedOrder: "",
      order: [],
      row_data: [],
      arr_data: [],
      isDisabledApply: false,
      disabledcheck: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      showTable: false,
      status_type: "1",
      apply: true,
      showUnAssignedOrder: false,
      showFetchDispatchData: false,
      selectedStation: "",
      disabledBtn: false,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      isChecked: false,
      filtered_posts: [],
    };
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    sessionStorage.setItem("PUstore_id", "");
    sessionStorage.setItem("PUpolaris_id", "");
    sessionStorage.setItem("PUstatus_type", "");
    sessionStorage.setItem("PUtask_type_value", "");
    sessionStorage.setItem("PUtask_id", "");

    /* sessionStorage.setItem('store_id', this.state.store_id)
    sessionStorage.setItem('polaris_id', this.state.polaris_id)
    sessionStorage.setItem('status_type', this.state.status_type)
    sessionStorage.setItem('task_type_value', this.state.task_type_value)
    sessionStorage.setItem('task_id', this.state.task_id)
*/

    var cookieUsername = Util.getCookie("token");
    var Location = Util.getCookie("selectedLocation");
    var username = Util.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
        store_id:
          sessionStorage.getItem("store_id") == "null"
            ? ""
            : sessionStorage.getItem("store_id"),
        polaris_id:
          sessionStorage.getItem("polaris_id") == "null"
            ? ""
            : sessionStorage.getItem("polaris_id"),
        task_id:
          sessionStorage.getItem("task_id") == "null"
            ? ""
            : sessionStorage.getItem("task_id"),
        status_type:
          sessionStorage.getItem("status_type") == "null" ||
          sessionStorage.getItem("status_type") == ""
            ? "1"
            : sessionStorage.getItem("status_type"),
        task_type_value:
          sessionStorage.getItem("task_type_value") == "null"
            ? ""
            : sessionStorage.getItem("task_type_value"),
      },
      () => {
        this.fetchDispatch();
      }
    );
  }

  fetchDispatch = (order_no) => {
    this.setState({
      loading_overlay: true,
      loading: true,
    });

     const payload={  
      master_type: "product_sub_category"
     }
    API.post('/jogeshwari/details/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          showFetchDispatchData: true,
          loading: false,
        });

        this.setState({
          orderData: data.data,
          filtered_posts: data.data,
          tableRowsMap: this.assembleDispatchData(data.data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function (error) {});
  };

  assembleDispatchData = (dispatchData) => {
    console.log("dispatchData", dispatchData);
    let DispatchData = dispatchData.map((post, index) => {
      return {
        category: post.category,
        sub_category: post.sub_category,
        rs_per_kg: post.rs_per_kg,
        rs_per_cft: post.rs_per_cft,
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_posts: this.state.orderData });
    } else {
      this.setState({
        filtered_posts: [],
      });
     
      // var value = this.state.orderData.filter(
      //   (val) =>
      //     val.sub_category.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.category.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.rs_per_kg.toString().includes(evt) ||
      //     val.rs_per_cft.toString().includes(evt)
      // );
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      this.setState({
        filtered_posts: value,
      });
    }
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2 } = this.state;
    const { SuccessConfirmmodal, Failedmodal } = this.state;

    const dispatchData = {
      columns: [
        {
          label: "Cateogory",

          field: "category",
          width: 120,
        },
        {
          label: "Sub Category",

          field: "sub_category",
          width: 120,
        },
        {
          label: "Rs Per KG",

          field: "rs_per_kg",
          width: 120,
        },
        {
          label: "Rs Per CFT",

          field: "rs_per_cft",
          width: 120,
        },
      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          {this.state.showFetchDispatchData && (
            <CardBody style={{ marginTop: 2, paddingTop: 0, paddingBottom: 0 }}>
              <div
                className="table_header"
                style={{ borderBottomWidth: "0px" }}
              >
                <h4
                  style={{
                    fontWeight: "bold",
                    width: "80%",
                    paddingTop: 10,
                    float: "left",
                  }}
                  className="subhead red-text"
                >
                  Sub Category Master
                </h4>

                <span
                  className="pull-right"
                  onClick={() =>
                    exportToCSV(
                      this.state.filtered_posts,
                      "Sub Category Master", Heading
                    )
                  }
                  style={{
                    fontSize: "17px",
                    paddingRight: "0px",
                    cursor: "pointer",
                    color: "#919193",
                    paddingTop: "9px",
                  }}
                >
                  <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                </span>
              </div>
              <hr style={{ marginTop: "30px", marginBottom: "0px" }} />

              <div className="dispatchData stock_check_data">
                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="390px"
                  sortable={false}
                  displayEntries={false}
                  striped
                  onSearch={this.filterData}
                  bordered
                  data={dispatchData}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'subcategory_master_vew', 'datatable_pagination_change' )}
                />
              </div>
            </CardBody>
          )}
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
